exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loginError {\n  color: red;\n  font-weight: bold;\n  text-align: center; }\n\n.pageSubCategory {\n  margin-left: 10vw; }\n\n.textUpdaterDiv {\n  margin: 2rem;\n  margin-left: 15vw;\n  margin-right: 15vw;\n  margin-bottom: 5rem; }\n\n/* Used to tell admin successful text content update */\n.updated {\n  margin: 1rem;\n  margin-top: -1rem;\n  padding: 1rem 2rem;\n  font-size: 1.5rem;\n  border: 2px solid #2c3e50;\n  border-radius: 0.5rem;\n  background-color: #f39c12;\n  color: #2c3e50; }\n\n/* Admin view, each image upload form */\n.imageUploadingForm {\n  padding: 5rem;\n  padding-left: 5rem;\n  border: 4px solid gray;\n  margin: -2px; }\n\n.imageUploadingForm:first-of-type {\n  margin-left: 2px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Jeremy/Desktop/EFA/jerusalem-temple/src/app/admin/admin.component.scss
// module id = ../../../../../src/app/admin/admin.component.scss
// module chunks = main